// BURGER MENU OPEN
toggleMainMenu();
// END BURGER MENU OPEN

if (checkMobDevice()) {
  mobileToggleSubmenu();
} else {
  rotateMenuArrow();
  desktopToggleLangs();
}
listenerSearchBlock();
toggleBasketBlock();
checkDisplayForBasket();
closeBasketKeyword();
if (document.querySelector(".second_header") !== null) {
  toggleSecondMenu();
  scrollSecondHeaderListener();
} else {
  scrollMainHeaderListener();
}

//SELECT
export function select() {
  let selectHeader = document.querySelectorAll(".select__header");
  let selectItem = document.querySelectorAll(".select__item");

  selectHeader.forEach((item) => {
    item.addEventListener("click", function () {
      closeAllSelect(this.parentElement);
      this.parentElement.classList.toggle("active");
    });
  });

  selectItem.forEach((item) => {
    item.addEventListener("click", function () {
      let dataID = this.getAttribute("data-id");
      let text = this.innerText,
        select = this.closest(".select"),
        currentText = select.querySelector(".select__current");
      currentText.innerText = text;
      currentText.setAttribute("data-id", dataID);
      select.classList.remove("active");
    });
  });
}

select();

window.addEventListener("click", function (event) {
  if (
    !event.target.classList.contains("select__header") &&
    !event.target.classList.contains("select__item") &&
    !event.target.classList.contains("select__item_applink") &&
    !event.target.classList.contains("select__header_applink") &&
    !event.target.classList.contains("select__item_profile") &&
    !event.target.classList.contains("select__header_profile") &&
    !event.target.classList.contains("select__item_term") &&
    !event.target.classList.contains("select__header_term") &&
    !event.target.classList.contains("select__item_cabinet_upgrade") &&
    !event.target.classList.contains("select__header_cabinet_upgrade") &&
    !event.target.classList.contains("select__current") &&
    !event.target.classList.contains("select__icon") &&
    !checkImgSelect(event.target)
  ) {
    closeAllSelect();
  }
});
function checkImgSelect(el) {
  if (el.closest(".select__icon")) {
    return true;
  } else {
    return false;
  }
}
export function closeAllSelect(el) {
  let allSelects = document.querySelectorAll(".select.active");
  for (let select of allSelects) {
    if (el !== null && select == el) {
    } else {
      select.classList.remove("active");
    }
  }
}
// END SELECT

// LOCK/UNLOCK DISPLAY
export function lockScroll() {
  let body = document.querySelector("body");
  if (document.querySelector(".second_header") !== null) {
    removeScrollSecondMenu();
  } else {
    removeScrollMainMenu();
  }
  body.setAttribute(
    "style",
    "position:fixed; top: -" +
      window.scrollY +
      "px; width: 100%; overflow-y: scroll;"
  );
  // menusForLock();
}
export function unlockScroll() {
  let body = document.querySelector("body");
  let bodyTop = body.style.top;
  if (bodyTop !== "") {
    bodyTop = bodyTop.split("-").join("");
    bodyTop = bodyTop.split("px").join("");
    body.removeAttribute("style");
    window.scrollTo(0, bodyTop);
  }
  addEventListener("scroll", checkEndScroll);
}
function checkEndScroll() {
  var scrollTimeout;
  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(function () {
    if (document.querySelector(".second_header") !== null) {
      scrollSecondHeaderListener();
      removeEventListener("scroll", checkEndScroll);
    } else {
      scrollMainHeaderListener();
      removeEventListener("scroll", checkEndScroll);
    }
  }, 100);
}
// END LOCK/UNLOCK DISPLAY

// CHECK MENU BASKET DOT ON BASKET PAGE
function checkBasketOnCards() {
  let wrapperBasket = document.querySelector(".wrapper_table_buy_card");
  if (wrapperBasket !== null) {
    if (wrapperBasket.querySelector("tr") === null) {
      document.querySelector(".basket_dot").classList.remove("active");
    }
  }
  let wrapperBasketMobile = document.querySelector(".wrapper_blocks_buy_card");
  if (wrapperBasketMobile !== null) {
    if (wrapperBasketMobile.querySelector(".block_buy_card_mobile") === null) {
      document.querySelector(".basket_dot").classList.remove("active");
    }
  }
}
checkBasketOnCards();
document.querySelector(".wrapper_table_buy_card") &&
  document
    .querySelector(".wrapper_table_buy_card")
    .addEventListener("click", () => {
      checkBasketOnCards();
    });
document.querySelector(".wrapper_blocks_buy_card") &&
  document
    .querySelector(".wrapper_blocks_buy_card")
    .addEventListener("click", () => {
      checkBasketOnCards();
    });
// END CHECK MENU BASKET DOT ON BASKET PAGE

// // COOKIES MODAL
// let cookiesModal = document.getElementById("cookiesModal");
// let btnCookiesModal = document.querySelector(".modal_cookies_btn_ok");
//
// setTimeout(() => {
//   if(localStorage.getItem('pilgwayCookies') == null) {
//     cookiesModal.style.display = "block";
//   }
// }, 3000);
//
// btnCookiesModal &&
// btnCookiesModal.addEventListener("click", function () {
//   cookiesModal.style.display = "none";
//   localStorage.setItem('pilgwayCookies', true)
//   });
// // END COOKIES MODAL